export enum UserRegistrationResult {
  Success,
  DuplicateUser,
  EmptyPassword,
  EmptyEMailAdress
}
